<form [formGroup]="uploadForm" (ngSubmit)="selectProofOption()">
    <div class="proof-option">
        <mat-radio-group formControlName="selectedOption" aria-label="Select an option" >
            <mat-label>Income Proof Type:</mat-label>
            <div class="row">
                <div class="col-xs-4">
                    <mat-radio-button value="17" [checked]="true">
                        <img src="https://images.5paisa.com/SPOT/activation/itr.png" />
                        ITR
                        <br>
                        <br>
                    </mat-radio-button>
                </div>
                <div class="col-xs-4">
                    <mat-radio-button value="23">
                        <img src="https://images.5paisa.com/SPOT/activation/passbook.png" />
                        Demat Holding<br>
                    </mat-radio-button>
                </div>
                <div class="col-xs-4">
                    <mat-radio-button value="19">
                        <img src="https://images.5paisa.com/SPOT/activation/copy-of-annual-accounts.png" />
                        Form 16
                    </mat-radio-button>
                </div>
                <!-- <div class="col-xs-4">
                    <mat-radio-button value="20">
                        <img src="https://images.5paisa.com/SPOT/activation/copy-of-annual-accounts.png" />
                        Net-worth<br>
                        Certificate
                    </mat-radio-button>
                </div> -->
                <div class="col-xs-4">
                    <mat-radio-button value="21">
                        <img src="https://images.5paisa.com/SPOT/activation/copy-of-annual-accounts.png" />
                        Salary Slip
                        <br>
                    </mat-radio-button>
                </div>
                @if(isBankStatement){
                    <div class="col-xs-4">
                    <mat-radio-button value="22">
                        <img src="https://images.5paisa.com/SPOT/activation-new/bankuploadoption.svg" />
                        Bank Statement
                        <br>
                    </mat-radio-button>
                </div>
                }
                 
            </div>
        </mat-radio-group>
        @if (!btnLoader) {
            <div class="bottom-button-wrapper btn position-relative">
                <button type="submit" class="btn btn-primary" [disabled]="uploadForm.get('selectedOption')?.invalid" >
                    Continue
                </button>
            </div>
        }@else{
            <div class="bottom-button-wrapper btn">
                <button class="btn btn-primary">
                    <span class="stage">
                        <span class="dot-pulse"></span>
                    </span>
                </button>
            </div>
        }
       
       
    </div>
</form>